import { isNullable } from '@app/utils'
import { objectMerge } from '@app/utils/object'

import type { Toolbar } from '@app/components/DropdownMenu/components/Toolbar/types'
import type { DropdownData, DropdownMenuItem } from '@app/types/dropdown'

export const setDropdownMenuItemSelect = (item: DropdownMenuItem, isSelect = false): DropdownMenuItem => ({
  ...item,
  isSelect
})

export const isSelectDropdownMenuItem = (item: DropdownMenuItem): boolean | undefined => item.isSelect

export const isDisableDropdownMenuItem = (item: DropdownMenuItem): boolean | undefined => item.isDisable

export const convertDropdownItemsToData = (items: DropdownMenuItem[]): DropdownData[] =>
  items.map<DropdownData>(({ label, value }) => ({ label, value }))

export const findPermittedDropdownMenuItems = (items: DropdownMenuItem[]): DropdownMenuItem[] =>
  items.filter(item => !isDisableDropdownMenuItem(item))

export const findSelectedDropdownMenuItems = (items: DropdownMenuItem[]): DropdownMenuItem[] =>
  items.filter(isSelectDropdownMenuItem)

export const findSelectedDropdownData = (items: DropdownMenuItem[]): DropdownData[] =>
  items.filter(isSelectDropdownMenuItem).map(item => ({ label: item.label, value: item.value }))

export const findPermittedAndSelectedDropdownMenuItems = (items: DropdownMenuItem[]): DropdownMenuItem[] =>
  findPermittedDropdownMenuItems(items).filter(isSelectDropdownMenuItem)

export const findPermittedAndSelectedDropdownData = (items: DropdownMenuItem[]): DropdownData[] =>
  findPermittedDropdownMenuItems(items)
    .filter(isSelectDropdownMenuItem)
    .map(item => ({ label: item.label, value: item.value }))

export const findDropdownMenuItemByValue = (
  items: DropdownMenuItem[],
  value: DropdownMenuItem['value']
): DropdownMenuItem | undefined => items.find(item => item.value === value)

export const getUnselectedDropdownMenuItems = (items: DropdownMenuItem[]): DropdownMenuItem[] =>
  items.map(item => (isDisableDropdownMenuItem(item) ? item : setDropdownMenuItemSelect(item)))

export const getSelectedDropdownMenuItems = (items: DropdownMenuItem[]): DropdownMenuItem[] =>
  items.map(item => (isDisableDropdownMenuItem(item) ? item : setDropdownMenuItemSelect(item, true)))

export const getUpdatedDropdownMenuItemsByItem = (
  items: DropdownMenuItem[],
  newItem: DropdownMenuItem
): DropdownMenuItem[] => {
  const newDropdownMenuItems = items.slice()
  const index = newDropdownMenuItems.findIndex(item => item.value === newItem.value)

  newDropdownMenuItems[index] = newItem

  return newDropdownMenuItems
}

export const getToolbar = (rawToolbar?: Toolbar, isMultiple?: boolean): Toolbar | undefined => {
  if (isMultiple && isNullable(rawToolbar?.accept)) {
    return objectMerge(rawToolbar, { accept: true })
  }

  return rawToolbar
}
